import { render, staticRenderFns } from "./UnitPage.vue?vue&type=template&id=81e87a38&"
import script from "./UnitPage.vue?vue&type=script&lang=js&"
export * from "./UnitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports